import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { Observable, of } from 'rxjs';
import { select } from '@angular-redux/store';
import { Itin } from '../core/itinerari/itinerari.model';

@Injectable()
export class ItinCarouselResolver implements Resolve<Itin[]> {
  @select(['itin', 'list'])
  itinList$: Observable<Itin[]>;

  constructor(private service: ApiService) {}

  resolve() {
    return this.service.getItinCarousel().pipe(
      first(),
      catchError((err) => {
        console.error('Non è stato possibile recuperare la lista di itinerari');
        return of(err);
      })
    );
  }
}
